import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// // @material-ui/icons
// import Chat from "@material-ui/icons/Chat";
// import VerifiedUser from "@material-ui/icons/VerifiedUser";
// import Fingerprint from "@material-ui/icons/Fingerprint";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NFTCard from "components/Card/Card2";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

export default function CardSection() {
    const classes = useStyles();
    return (
        <div className={classes.section}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6}>
                    <NFTCard

                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <h2 className={classes.title}>Let{"'"}s talk NFT</h2>
                    <h5 className={classes.description}>
                        In a land far, far away exists supernatural creatures,<br /> that we humans like to call "Animals"
                        <br />
                        However, we have discovered their true talents, <b>Athletic Abilities!</b>
                        <br />
                        Follow us on our path as we divulge into the world of Athletic Animals,
                        where creatures of far an wide fight through radical challenges on the <b>Cardano Blockchain</b>
                    </h5>
                </GridItem>

            </GridContainer>
            <div>

            </div>
        </div>
    );
}
